<div *ngFor="let data of scheduleData">
  <div [ngClass]="{ month: data.month == 0, 'other-month': data.month > 0 }">
    <div class="ui-g">
      <div
        *ngIf="data.month == 0"
        class="ui-g-12 ui-lg-1 ui-md-1 prev"
        (click)="prevMonthClicked()"
      >
        &#10094;
      </div>

      <div *ngIf="data.month == 0" class="ui-g-12 ui-lg-10 ui-md-10">
        {{ data.monthName + ' ' + data.year }}
      </div>
      <div *ngIf="data.month > 0" class="ui-g-12 ui-lg-12 ui-md-12">
        {{ data.monthName + ' ' + data.year }}
      </div>

      <div
        *ngIf="data.month == 0"
        class="ui-g-12 ui-lg-1 ui-md-1 next"
        (click)="nextMonthClicked()"
      >
        &#10095;
      </div>
    </div>
  </div>

  <div *ngIf="data.month == 0" class="day-of-week">
    <div *ngFor="let column of dayData" #colDay class="weekday">{{ column.weekdayName }}</div>
  </div>
  <div *ngFor="let week of data.dayData" class="date-grid">
    <div
      *ngFor="let day of week; let i = index"
      class="day-container"
      (click)="dayClicked(day)"
      [ngClass]="{
        day: !day.inactive,
        'day-inactive': day.inactive && !day.isOtherMonth,
        'day-other-month': day.isOtherMonth
      }"
      [escape]="false"
      tooltipStyleClass="xtooltip"
      [pTooltip]="getAvailabilityTooltip(day)"
    >
      <div
        *ngIf="!day.inactive && day.availabilityState == SupplierAvailabilityStateEnum.available"
      >
        <i class="fa fa-check is-available availability-image"></i>
      </div>
      <div
        *ngIf="!day.inactive && day.availabilityState == SupplierAvailabilityStateEnum.unavailable"
      >
        <i class="fa fa-times-circle not-available availability-image"></i>
      </div>
      <div
        *ngIf="!day.inactive && day.availabilityState == SupplierAvailabilityStateEnum.doNotDisturb"
      >
        <i class="fa fa fa-minus-circle not-available availability-image"></i>
      </div>
      <div *ngIf="!day.inactive && day.availabilityState == null">
        <i class="fa fa-exclamation-triangle fa-sm unknown availability-image"></i>
      </div>
      <div class="day-right">{{ day.day }}</div>
    </div>
  </div>
</div>
